<template>
  <o-do-server-action-button
    class="btn btn-primary"
    :uri="getUrl"
    :do-save="doSave"
    :request="request"
    @success="success"
    :variant-color="getVariant"
  >
    {{ trigger.params.buttonText }}
  </o-do-server-action-button>
</template>

<script>
export default {
  name: "TriggerButton",
  data() {
    return {
      showFormRejection: false,
      rejectRequest: "reject_request",
    };
  },
  props: {
    trigger: { type: Object, default: () => {} },
    item: { type: Object, default: () => {} },
    instanceId: {},
    doSave: { type: Function, default: null },
  },
  methods: {
    success(data) {
      this.$emit("success", data);
    },
  },
  computed: {
    getUrl() {
      return "/workflow/v1/trigger/";
    },
    getVariant() {
      if (this.trigger.params.variant) return this.trigger.params.variant;

      if (!this.trigger.params.button_color) {
        return "primary";
      }

      if (this.trigger.params.button_color == 2) {
        return "success";
      }

      if (this.trigger.params.button_color == 3) {
        return "danger";
      }

      return "primary";
    },
    request() {
      return {
        id: this.instanceId,
        trigger: this.trigger.id,
        item: this.item,
      };
    },
  },
};
</script>

<style scoped></style>
